import { render, staticRenderFns } from "./DarkMatterDimensionGroup.vue?vue&type=template&id=d9b21988&"
import script from "./DarkMatterDimensionGroup.vue?vue&type=script&lang=js&"
export * from "./DarkMatterDimensionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports